module.exports = __webpack_public_path__ + "img/sec-7_icon-monit.b4d842bd.svg";